import { createFileRoute, redirect } from "@tanstack/react-router";
// "roof-replacement-cost" on the old WP site maps to the "cost-guides" category here.
export const Route = createFileRoute("/category/roof-replacement-cost")({
  beforeLoad: () => { throw redirect({ to: "/blog/category/$category", params: { category: "cost-guides" }, statusCode: 301 }); },
});
